<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Transactions</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Refunds
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Refunds</h4>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="start_date">By Start Date</label>
                                    <date-time-field id="start_date" class="form-control" v-model="filters.date_from" bound="start"></date-time-field>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="end_date">By End Date</label>
                                    <date-time-field id="end_date" class="form-control" v-model="filters.date_to" bound="end"></date-time-field>
                                </div>
                            </div>
                            <div class="col-md-4 mb-4">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="search-container pb-2">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center">
                                <input id="search-term" type="text"
                                       class="table-search form-control form-control-sm"
                                       placeholder="🔍 Search this table by user name, order number or cost"
                                       v-model="searchTerm"
                                       @keyup="paginatedData"
                                >
                            </div>
                        </div>
                    </div>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allRefunds"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'user.first_name'">
                                <a v-if="props.row.user" :href="`/customers?id=${props.row.user.id}`">{{ formatFullName("", props.row) }}</a>
                                <span v-else>—</span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Refunds'},
    props: [
        'refunds',
    ],
    layout: Layout,
    name: 'RefundIndex',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            filters: {
                date_from: null,
                date_to: this.getCurrentDate(),
            },
            isLoadingFilter: false,
            allRefunds: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10,
                columnFilters: {},
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Order ID',
                    field: 'order.order_no',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {
                    label: 'User name',
                    field: 'user.first_name',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFullName
                },
                {
                    label: 'User Email',
                    field: 'user.email',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Refund Made By',
                    field: 'admin.first_name',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatAdminName
                },
                {label: 'Created At', field: 'created_at', thClass: 'text-center', formatFn: this.formatDate},
            ],
            searchTerm: '',
            tableDataLoading: false,
        }

    },
    mounted() {
        this.allRefunds = this.refunds.data;
        this.totalRecords = this.refunds.total;
    },

    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.transactions.refunds';

                let response = await axios.get(route(routeName), {
                    params: {
                        q: this.searchTerm,
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allRefunds = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            this.searchTerm = '';
            await this.paginatedData();
        },
        formatFn(value) {
            return '₦' + (value ?? 0);
        },
        formatFullName(value, row) {
            if (! row.user) {
                return '—';
            }

            return `${row.user.first_name} ${row.user.last_name}`;
        },
        formatAdminName(value, row) {
            return `${row.admin.first_name} ${row.admin.last_name}(${row.admin.email})`;
        },
        formatDate(value) {
            return formatDateTime(value);
        },
        getCurrentDate() {
            const local = new Date();
            local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
            return local.toJSON().slice(0, 10);
        },
    }
}
</script>
